import React, {Component} from 'react';
import {Query, Builder, Utils} from 'react-awesome-query-builder';
import config from './Config';

import './../../Static/Css/query-builder.css';

const { queryString } = Utils;

class QueryBuilder extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
          "filters" : "",
        }
        this.getChildren = this.getChildren.bind(this);
    }

    getChildren(props) {
        const jsonStyle = { backgroundColor: 'darkgrey', margin: '10px', padding: '10px' };
        this.state.filters = queryString(props.tree, props.config);
        return (
            <div>
                <div className="query-builder">
                    <Builder {...props} />
                </div>
                <div className="text-center px-3">
                    <button className="btn btn-primary" style={{"width" : "100%"}}  onClick={ () => { this.props.handleQueryBuilder(this.state.filters) }} >
                        <li className="fas fa-search-plus"> </li> Rechercher
                    </button>
                </div>
            </div>
        )
    }

    render() {
        const {tree, ...config_props} = config;
        return (
            <div style={{width: '100%'}}>
                <Query 
                    {...config_props} 
                    get_children={this.getChildren}
                > </Query>
            </div>
        );
    }
}
export default QueryBuilder;


// WEBPACK FOOTER //
// ./src/Components/QueryBuilder/QueryBuilder.js